import React from "react";

const BS5_Navbar = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Navbar Component</h2>
      <p>This is the BS5_Navbar component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Navbar;
